<template>
<div class="logs-outer">
  <div class="logs-container">
    <div class="group-logs" >
      <h3>Logs</h3>
      <LogViewLogs :pp-player-ref='ppPlayerRef' :log='log' class="group"/>
    </div>

    <div class="group-events">
      <h3>Events</h3>
      <LogViewEvents :pp-player-ref='ppPlayerRef' :events='events' class="group"/>
    </div>
  </div>
</div>

</template>

<script>
import LogViewLogs from './info/LogViewLogs';
import LogViewEvents from './info/LogViewEvents';

export default {
  name: 'PlayerLogs',
  props: ['ppPlayerRef', 'log', 'events'],
  components: {
    LogViewEvents,
    LogViewLogs
  }
};
</script>

<style scoped lang="scss">

@import "../../style/color_";

.logs-outer {
  flex: 1 1 100%;
}

.logs-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  h3 {
    margin: 0;
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1.6rem;
    color: $color-secondary
  }

  .group {
    border: 1px solid $color-tertiary;
    overflow: auto;
    width: 100%;
    height: calc(100vh - 610px);
    min-height: 250px;
  }

  .group-events {
    flex: 1 1 auto;
    min-width: 320px;
    width: 480px;
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .group-logs {
    flex: 1 1 auto;
    min-width: 320px;
    width: 480px;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

</style>
